<ion-header>
  <ion-toolbar mode="md" color="dark">
    <ion-buttons slot="start">
      <ion-button
        *ngIf="view === 'custom-price' || (view === 'scan' && isVariable) || view === 'manual' || view === 'select' || view ==='summary'"
        mode="md"
        color="orange"
        fill="solid"
        debounce-click
        [debounceTime]="0"
        (debounceClick)="onBack()">
        <ion-icon name="arrow-back-outline"></ion-icon>
        {{ 'common.back' | transloco }}
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'payment.addGiftCard' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-button
        mode="md"
        debounce-click
        [debounceTime]="0"
        (debounceClick)="onCloseModal()"
        >{{ 'common.close' | transloco }}</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar
    mode="md"
    color="orange"
    *ngIf="view !== 'list'"
    class="subheader">
    <ion-title
      >{{ price ? ('payment.addingGiftCard' | transloco: { price: (price |
      currency) }) : ('payment.addingCustomGiftCard' | transloco) }}</ion-title
    >
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div class="gift-card-modal">
    <div class="gift-card-modal__list" *ngIf="view === 'list'">
      <p>{{ 'payment.pleaseSelectAmount' | transloco }}</p>
      <div class="gift-card-modal__list__items">
        <ion-card
          *ngFor="let amount of [5,10,15,20,30,50,75,100]"
          color="whitesmoke"
          class="gift-card-modal__list__item"
          debounce-click
          [debounceTime]="0"
          (debounceClick)="onSelectGiftCard(amount)">
          <ion-card-header>
            <ion-card-title>{{amount | currency}}</ion-card-title>
          </ion-card-header>
        </ion-card>
        <ion-card
          color="whitesmoke"
          class="gift-card-modal__list__item"
          debounce-click
          [debounceTime]="0"
          (debounceClick)="onSelectGiftCard()">
          <ion-card-header>
            <ion-card-title>{{ 'menu.custom' | transloco }}</ion-card-title>
          </ion-card-header>
        </ion-card>
      </div>
    </div>
    <div class="gift-card-modal__custom-price" *ngIf="view === 'custom-price'">
      <p>{{ 'payment.enterCustomAmount' | transloco }}</p>
      <pos-numeric-keyboard
        [buttons]="[]"
        (onValueChange)="amount = $event"
        (submitEvent)="onConfirmCustomAmount()"></pos-numeric-keyboard>
    </div>
    <div class="gift-card-modal__scan" *ngIf="view === 'scan'">
      <p>{{'payment.pleaseSwipeOrScanGiftCardWithoutBr' | transloco}}</p>

      <div>
        <div>
          <img src="assets/icon/gift_card_scan.svg" />
          <label>{{ 'payment.scan' | transloco }}</label>
        </div>
        <label>{{ 'common.or' | transloco }}</label>
        <div>
          <img src="assets/icon/gift_card_swipe.svg" />
          <label>{{ 'payment.swipe' | transloco }}</label>
        </div>
      </div>
    </div>
    <div class="gift-card-modal__manual" *ngIf="view === 'manual'">
      <p>{{ 'payment.enterGiftCardNumberPrompt' | transloco }}</p>
      <ion-input
        type="text"
        [placeholder]="'payment.giftCardNumber' | transloco"
        [(ngModel)]="gift_card_code"></ion-input>
    </div>
    <div class="gift-card-modal__select" *ngIf="view === 'select'">
      <p>{{ 'payment.multipleGiftCardsFound' | transloco }}</p>
      <pos-gift-card-selection
        [giftCards]="matchingGiftCards"
        (cardTapped)="onGiftCardSelected($event)"></pos-gift-card-selection>
    </div>
    <div class="gift-card-modal__summary" *ngIf="view === 'summary'">
      <h1>{{ 'payment.giftCardNumberLabel' | transloco }}</h1>
      <h2>#{{ gift_card_code }}</h2>
    </div>
  </div>
</ion-content>
<ion-footer *ngIf="view !== 'list'">
  <ion-toolbar mode="md" color="light">
    <ion-buttons slot="end">
      <ion-button
        *ngIf="view === 'custom-price'"
        mode="md"
        color="dark"
        fill="solid"
        debounce-click
        [debounceTime]="0"
        (debounceClick)="onConfirmCustomAmount()"
        >{{ 'payment.confirmCustomAmount' | transloco }}</ion-button
      >
      <ion-button
        *ngIf="view === 'scan'"
        mode="md"
        color="dark"
        fill="solid"
        debounce-click
        [debounceTime]="0"
        (debounceClick)="onManualGiftCardEntry()"
        >{{ 'payment.manualEntry' | transloco }}</ion-button
      >
      <ion-button
        *ngIf="view === 'manual'"
        mode="md"
        color="dark"
        fill="solid"
        debounce-click
        [debounceTime]="0"
        (debounceClick)="onConfirmGiftCardNumber()"
        >{{ 'payment.confirmGiftCardNumber' | transloco }}</ion-button
      >
      <ion-button
        *ngIf="view === 'summary'"
        mode="md"
        color="dark"
        fill="solid"
        debounce-click
        [debounceTime]="0"
        (debounceClick)="onAddToTicket()"
        >{{ 'pos.addItem' | transloco | uppercase }}</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
